import { useEffect } from 'react';
import { InternalAxiosRequestConfig } from 'axios';
import { useAxios } from './use-axios';
import { isDevelopment } from '../../environment';

export const usePathInterceptor = (): void => {
    const axios = useAxios();

    useEffect(() => {
        const requestInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
            config.baseURL = isDevelopment ? config.baseURL : window.location.origin;
            config.url = !config.url?.startsWith('api') ? `api/${config.url}` : config.url;
            return config;
        };

        axios.interceptors.request.use(requestInterceptor);
    }, [axios.interceptors.request]);
};
